"use client";
import { ArrowRight, Clock, ZoomIn } from "lucide-react";
import Image from "next/image";
import { useRef, useState } from "react";
import { ImageModal } from "../modals/ImageModal";

export function CardServices({ service, index }) {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    card.style.transition = "none";
    card.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) scale3d(1.02,1.02,1.02)`;
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;
    if (!card) return;
    card.style.transition = "transform 0.3s ease-out";
    card.style.transform = "";
  };

  const handleImageClick = () => {
    setIsImageModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <>
      <div
        ref={cardRef}
        className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl overflow-hidden border border-slate-200/50 flex flex-col h-full will-change-transform"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {/* Service Image */}
        <div
          className="relative h-56 overflow-hidden cursor-pointer flex-shrink-0"
          onClick={handleImageClick}
        >
          <Image
            src={service.image}
            alt={service.name}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
            className="object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

          {/* Zoom indicator - appears on hover */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/20">
            <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg">
              <ZoomIn className="w-6 h-6 text-gray-700" />
            </div>
          </div>
        </div>

        {/* Service Content */}
        <div className="p-8 flex flex-col gap-4 flex-grow">
          <h3 className="text-2xl font-bold text-title mb-2 group-hover:text-primary transition-colors duration-300 leading-tight">
            {service.name}
          </h3>
          <div className="flex-grow flex flex-col">
            <p className="text-slate-600 leading-relaxed text-sm mb-4 flex-grow">
              {service.description}
            </p>

            {/* Features */}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <ImageModal
        isOpen={isImageModalOpen}
        onClose={handleCloseModal}
        images={service.imageList}
        title={service.name}
      />
    </>
  );
}
